import { useMemo } from 'react';

import { atom, useRecoilValue } from 'recoil';

import { WorkflowState } from './types';

export const workflowsAtom = atom<{
  [key: string]: WorkflowState;
}>({
  key: 'workflowsAtom',
  default: {},
});

export const useCalculationItemValue = (id: string): WorkflowState => {
  const workflowValue = useRecoilValue(workflowsAtom);
  return useMemo(() => workflowValue[id], [workflowValue, id]);
};
